<template>
    <div class="image_saver_path">
        <div class="box" @click="transferAimsDialogShow">
            <div class="text">{{ $t('language.imageSaver.uploadTo') }}</div>
            <div class="icon" :class="(node && node.type)+'-small'"></div>
            <div class="path">{{ node && newPath }}</div>
            <img class="edit_path_icon" src="../../assets/images/imageSaver/editPath.svg" />
        </div>
        <!-- 保存目的地弹窗 -->
        <transferAimsDialog ref="transferAimsDialog"></transferAimsDialog>
    </div>
</template>

<script>
import transferAimsDialog from "@/components/popup/cloud_transfer_popups/task_single_popup";

export default {
    name: "imageSaverPath",
    props: ['node','updateTaskDestDrive', 'loadDestNode'],
    components: {
        transferAimsDialog,
    },
    data() {
        return {
            pageName:'imageSaver',
        };
    },
    computed: {
        // 保持目的地路径最新
        newPath() {
            var driveName = null;
            var drives = this.$store.getters.getUsersDrives;
            for (var i=0; i<drives.length; i++) {
                if (drives[i].id == this.node.id) {
                    driveName = drives[i].name;
                    break;
                }
            }
            if (driveName == null) {
                // 云盘不存在，重新加载来清空节点
                this.loadDestNode();
            } else {
                // 云盘存在，使用最新的云盘名称
                var newPath = '';
                var arr = JSON.parse(this.node.path);
                for (var i=0; i<arr.length; i++) {
                    newPath = (i==arr.length-1 ? driveName : arr[i].name) + '/' + newPath;
                }
                return newPath;
            }
        }
    },
    methods: {
        //打开目标路径选择弹窗
        transferAimsDialogShow() {
            this.$refs.transferAimsDialog.taskSingleShow = true;
        },
        // 设置选择的Node
        setNode(node) {
            this.updateTaskDestDrive(node);
        },
    }
};
</script>

<style>
/* 路径组件 */
.image_saver_path {
    padding-bottom: 30px;
}

/* 路径外框 */
.image_saver_path>.box {
    height: 50px;
    border-radius: 2px;
    margin-top: 5px;
    background: #FFFFFF;
    box-sizing: border-box;
    border: 1px solid #E0EAF9;
    cursor: pointer;
}

/* 云盘图标 */
.image_saver_path>.box>.icon {
    display: inline-block;
    vertical-align: middle;
    margin-left: 5px;
}

/* 路径提示文字 */
.image_saver_path>.box>.text {
    display: inline-block;
    vertical-align: middle;
    margin-left: 20px;
    line-height: 50px;
    font-size: 14px;
    color: #3D3D3D;
}

/* 路径文字 */
.image_saver_path>.box>.path {
    display: inline-block;
    vertical-align: middle;
    margin-left: 10px;
    line-height: 50px;
    font-size: 14px;
    color: #3D3D3D;
    max-width: calc(100% - 250px);
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
}

/* 编辑路径图片 */
.image_saver_path>.box>.edit_path_icon {
    display: inline-block;
    vertical-align: top;
    margin-left: 10px;
    margin-top: 17px;
}
</style>



// WEBPACK FOOTER //
// src/components/workspace/image_saver_path.vue